import React from 'react';
const SvgIfc = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#064C94" d="M3 31h26V8h-7V1H3z" />
        <path fill="#FFF" d="M4 2v20h24V8h-6V2z" />
        <path fill="#222" opacity={0.1} d="M29 15l-7-7h7z" />
        <path fill="#236BB3" d="M22 1l7 7h-7z" />
        <g>
          <path
            d="M14.834 13.485l1.06-1.06 1.061 1.06c.566.566.566 1.556 0 2.121l-2.121-2.121z"
            fill="#B62993"
            fillRule="nonzero"
          />
          <path
            d="M14.692 13.344l-.141.14.141.142 2.122 2.122.141.141.142-.141a1.685 1.685 0 000-2.404l-1.061-1.061-.142-.142-.141.142-1.06 1.06z"
            stroke="#FFF"
          />
          <path
            d="M14.551 11.08l1.06 1.061-1.06 1.061c-.566.566-1.556.566-2.121 0l2.121-2.121z"
            fill="#005DA4"
            fillRule="nonzero"
          />
          <path
            d="M14.692 10.94l-.141-.142-.141.141-2.122 2.122-.141.141.141.142a1.685 1.685 0 002.404 0l1.061-1.061.141-.142-.141-.141-1.06-1.06z"
            stroke="#FFF"
          />
          <g>
            <path
              d="M14.197 10.727c-.565-.565-1.555-.565-2.12 0L9.6 13.202c-.565.566-.565 1.556 0 2.121l2.758 2.758c.566.566 1.556.566 2.121 0l.707-.707-1.06-1.06-.707.706-2.829-2.828 1.627-1.626c.07.07 1.98-1.839 1.98-1.839z"
              fill="#B62993"
              fillRule="nonzero"
            />
            <path
              d="M13.49 16.667l-2.475-2.475 1.415-1.414 1.909-1.91.141-.14-.141-.142a1.685 1.685 0 00-2.404 0L9.46 13.06a1.685 1.685 0 000 2.404l2.758 2.758a1.685 1.685 0 002.404 0l.707-.708.212-.212-.142-.141-1.06-1.06-.142-.142-.141.141-.566.566h0z"
              stroke="#FFF"
            />
          </g>
          <g>
            <path
              d="M17.309 13.131l-1.061-1.06 1.06-1.06c.566-.567 1.556-.567 2.122 0l-2.121 2.12z"
              fill="#CC0092"
              fillRule="nonzero"
            />
            <path
              d="M17.097 13.344l.141.14.141-.14 2.122-2.122.212-.212-.142-.141a1.685 1.685 0 00-2.404 0l-1.06 1.06-.142.142.142.141 1.06 1.06-.07.072z"
              stroke="#FFF"
            />
            <path
              d="M14.834 13.485l1.06-1.06 1.061 1.06c.566.566.566 1.556 0 2.121l-2.121-2.121z"
              fill="#CC0092"
              fillRule="nonzero"
            />
            <path
              d="M14.692 13.344l-.141.14.141.142 2.122 2.122.141.141.142-.141a1.685 1.685 0 000-2.404l-1.061-1.061-.142-.142-.141.142-1.06 1.06z"
              stroke="#FFF"
            />
            <g>
              <path
                d="M14.48 13.838c-.565.566-.565 1.556 0 2.122l2.475 2.475c.566.565 1.556.565 2.121 0l2.758-2.758c.566-.566.566-1.556 0-2.121l-.707-.707-.99.99.707.707-2.828 2.828-1.556-1.556-1.98-1.98z"
                fill="#00A6BB"
                fillRule="nonzero"
              />
              <path
                d="M20.42 14.546l-2.404 2.404-1.414-1.414-1.91-1.91-.141-.141-.141.141a1.685 1.685 0 000 2.405l2.474 2.474a1.685 1.685 0 002.405 0l2.757-2.757a1.685 1.685 0 000-2.404l-.707-.708-.141-.141-.142.141-1.06 1.061-.212.212.141.142.495.495z"
                stroke="#FFF"
              />
            </g>
          </g>
          <g>
            <path
              d="M16.955 10.656l-1.06 1.061-1.061-1.06c-.566-.566-.566-1.556 0-2.122l2.121 2.121z"
              fill="#0055A9"
              fillRule="nonzero"
            />
            <path
              d="M17.167 10.869l.142-.142-.142-.141-2.121-2.122-.141-.141-.142.141a1.685 1.685 0 000 2.405l1.06 1.06.142.142.142-.142 1.06-1.06z"
              stroke="#FFF"
            />
            <path
              d="M17.309 13.131l-1.061-1.06 1.06-1.06c.566-.567 1.556-.567 2.122 0l-2.121 2.12z"
              fill="#00A6BB"
              fillRule="nonzero"
            />
            <path
              d="M17.097 13.344l.141.14.141-.14 2.122-2.122.141-.141-.141-.142a1.685 1.685 0 00-2.404 0L16.036 12l-.142.141.142.142 1.06 1.06z"
              stroke="#FFF"
            />
            <g>
              <path
                d="M17.662 13.485c.566.566 1.556.566 2.122 0l2.474-2.475c.566-.566.566-1.556 0-2.121L19.501 6.13c-.566-.566-1.556-.566-2.122 0l-.707.707 1.06 1.06.708-.706 2.828 2.828-1.626 1.626c-.07-.07-1.98 1.839-1.98 1.839z"
                fill="#FF003B"
                fillRule="nonzero"
              />
              <path
                d="M18.37 7.545l2.474 2.475-1.414 1.414-1.91 1.91-.211.212.141.141a1.685 1.685 0 002.404 0l2.475-2.475a1.685 1.685 0 000-2.404L19.571 6.06a1.685 1.685 0 00-2.404 0l-.707.707-.141.142.141.141 1.06 1.06.142.142.142-.141.565-.566z"
                stroke="#FFF"
              />
            </g>
          </g>
          <g>
            <path
              d="M14.551 11.08l1.06 1.061-1.06 1.061c-.566.566-1.556.566-2.121 0l2.121-2.121z"
              fill="#0055A9"
              fillRule="nonzero"
            />
            <path
              d="M14.692 10.94l-.141-.142-.141.141-2.122 2.122-.141.141.141.142a1.685 1.685 0 002.404 0l1.061-1.061.141-.142-.141-.141-1.06-1.06z"
              stroke="#FFF"
            />
            <path
              d="M16.955 10.656l-1.06 1.061-.99-.99c-.566-.565-.566-1.555 0-2.121l2.05 2.05z"
              fill="#FF003B"
              fillRule="nonzero"
            />
            <path
              d="M17.167 10.869l.142-.142-.142-.141-2.121-2.122-.141-.141-.142.141a1.685 1.685 0 000 2.405l1.06 1.06.142.142.142-.142 1.06-1.06z"
              stroke="#FFF"
            />
            <g>
              <path
                d="M17.309 10.303c.565-.566.565-1.556 0-2.121l-2.475-2.475c-.566-.566-1.556-.566-2.122 0L9.955 8.464c-.566.566-.566 1.556 0 2.122l.707.707 1.06-1.06-.707-.708 2.829-2.828 1.555 1.555c0 .142 1.91 2.05 1.91 2.05z"
                fill="#0055A9"
                fillRule="nonzero"
              />
              <path
                d="M11.369 9.596l2.404-2.404 1.414 1.414 1.91 1.91.141.14.141-.14a1.685 1.685 0 000-2.405l-2.474-2.475a1.685 1.685 0 00-2.405 0L9.743 8.394a1.685 1.685 0 000 2.404l.707.707.141.141.142-.141 1.06-1.06.142-.142-.142-.141-.495-.495.071-.071z"
                stroke="#FFF"
              />
            </g>
          </g>
        </g>
        <path
          d="M11 24.114h.636v4.779H11v-4.78zm1.707 0h3.14v.535h-2.504v1.52h2.195v.535h-2.195v2.189h-.636v-4.78zm7.202 1.439c-.071-.34-.229-.594-.472-.763a1.477 1.477 0 00-.867-.255c-.285 0-.53.054-.733.161-.203.107-.37.251-.502.432-.131.18-.228.387-.29.619a2.769 2.769 0 00-.095.723c0 .272.032.53.094.773.063.243.16.455.291.636.132.18.3.324.506.432.205.107.45.16.736.16.21 0 .396-.034.559-.104a1.265 1.265 0 00.7-.726c.066-.17.106-.352.12-.549h.636c-.063.603-.27 1.071-.623 1.406-.352.335-.834.502-1.446.502-.37 0-.693-.064-.97-.19a1.906 1.906 0 01-.69-.526 2.257 2.257 0 01-.411-.79 3.37 3.37 0 01-.137-.977c0-.348.049-.675.147-.98.098-.307.242-.573.432-.8.19-.228.426-.408.71-.54.282-.131.607-.197.973-.197.25 0 .486.033.71.1.223.067.421.166.595.295.174.13.32.291.435.485.116.194.192.419.228.673h-.636z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
});
export default SvgIfc;
SvgIfc.iconName = 'ifc';
SvgIfc.displayName = 'SvgIfc';
